import Resolutions from './routes/resolutions'
import Ags3 from './routes/ags3'
import Votes from './routes/votes'
import Prestas from './routes/prestas'
import Copros from './routes/copros'
import Pvags from './routes/Pvags'
import Ags from './routes/ags'
import ExtAgs from './routes/ext_ags'
import Tickets from './routes/tickets'
import Invoices from './routes/invoices'
import Users from './routes/users'
import Coproprietaires from './routes/coproprietaires'
import Contracts from './routes/contracts'
import References from './routes/references'
import ExtCoprosummary from './routes/ext_coprosummary'
import FileWithContext from './routes/file_with_context'
import ExtContactpref from './routes/ext_contactpref'
import Massmails from './routes/massmails'
import Athome from './routes/athome'

const Api = {
  resolutions: new Resolutions(),
  ags: new Ags(),
  ags3: new Ags3(),
  extAgs: new ExtAgs(),
  votes: new Votes(),
  prestas: new Prestas(),
  copros: new Copros(),
  pvags: new Pvags(),
  tickets: new Tickets(),
  invoices: new Invoices(),
  users: new Users(),
  coproprietaires: new Coproprietaires(),
  contracts: new Contracts(),
  references: new References(),
  extCoprosummary: new ExtCoprosummary(),
  fileWithContext: new FileWithContext(),
  extContactpref: new ExtContactpref(),
  massmails: new Massmails(),
  athome: new Athome(),
}

export default Api
